import React from 'react';

export const Input = React.forwardRef(({ 
  id, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  required = false,
  className = '',
  ...props
}, ref) => {
  return (
    <input
      ref={ref}
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      className={`input ${className}`}
      {...props}
    />
  );
});

export const InputCheck = ({
  id,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  className = '',
  status = 'idle', // 'idle' | 'loading' | 'error' | 'success'
  onCheckClick,
  ...props
}) => {
  return (
    <div className="input-check-wrapper">
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`input input-check-field ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={onCheckClick}
        disabled={status === 'loading' || status === 'success'}
        className={`input-check-box input-check-box--${status}`}
        aria-label="Webseite prüfen"
      >
        {status === 'loading' && (
          <span className="input-check-spinner" />
        )}
        {status === 'success' && (
          <svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 7l3.5 3.5L12 3" />
          </svg>
        )}
        {status === 'error' && (
          <svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="3" y1="3" x2="11" y2="11" />
            <line x1="11" y1="3" x2="3" y2="11" />
          </svg>
        )}
      </button>
    </div>
  );
};

